import AbstractStorageCookieBasedAuthHttpInterceptor from './AbstractStorageCookieBasedAuthHttpInterceptor';

export default class LocalStorageCookieBasedAuthHttpInterceptor
    extends AbstractStorageCookieBasedAuthHttpInterceptor {
  constructor() {
    super(localStorage);
  }
}
